import siteName from '../config';

const SITENAMES = {
  fleetpartners: "FleetPartners",
  fleetplus: "FleetPlus",
  fleetsmart: "FleetSmart"
};

const SITEPHONES = {
  FleetPartners: "1300 666 001",
  FleetPlus: "1300 353 381",
  FleetSmart: "0800 800 358"
};

export const getSiteName = () => siteName;

export const getFullSiteName = () => {
  let host = location.host;

  let siteCom = ".com.au";

  for (const site in SITENAMES) {
    if (host.indexOf(site) > -1) {
      const index = host.indexOf(site);
      host = host.substring(index);
      host = host.substring(site.length);
      siteCom = host;
    }
  }

  return `www.${siteName}${siteCom}`;
};

export const getSitePhone = () => {
  return SITEPHONES[siteName];
};



// WEBPACK FOOTER //
// ./src/utils/url.js